import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=61ffddcf&scoped=true"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmationDialog.vue?vue&type=style&index=0&id=61ffddcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ffddcf",
  null
  
)

export default component.exports